import { useRouter } from 'next/router'
import { useWorkspace } from '~workspace/states/workspace'
import View from './view'

const TagPicker = (props) => {
  const router = useRouter()
  const workspace = useWorkspace()

  const tagOptions = workspace?.tagCollection?.items || []

  const selectedTags = tagOptions.filter(
    (tag) => router.query.tags && router.query.tags.split(',').includes(tag.id)
  )

  const handleChange = (event, value) => {
    const newQuery = { ...router.query, page: 1 }

    if (!value.length) delete newQuery.tags
    else newQuery.tags = value.map((option) => option.id).join(',')

    router.replace({ query: newQuery }, undefined, {
      shallow: true
    })
  }

  return (
    <View
      {...props}
      filterOnSearch={true}
      options={tagOptions}
      value={selectedTags}
      onChange={handleChange}
    />
  )
}

export { TagPicker }
export default TagPicker
